import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from '../../../services/notification.service';
import { FormularioService } from '../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { TypeMessage } from 'src/app/entity/enum/enum-notification';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-rs005-card-XI',
    templateUrl: './rs005-card-XI.component.html'
})

export class Rs005CardXIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public listTipoDefeito?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listTipoDefeitoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    // public filteredConfigRolos: Observable<DropDownListDTO[]>;
    // public filteredTipoCalha: Observable<DropDownListDTO[]>;
    // public listConfigRolos?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    // public listTipoCalha?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    // public listConfigRolosOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    // public listTipoCalhaOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    public tipoDefeitosIsEnabled: boolean = false;
    @Output() objMakeCalculations = new EventEmitter();

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Avaliação de Outros Defeitos', false);
        this.formulario = this.formBuilder.group({
            total_espigas_outros_defeitos: [null, []],
            tipo_defeito: [null, []],
            outro_defeito: [null, []],
            outros_defeitos_prc: [null, []],
        });
    }

    async ngOnInit(): Promise<void> {
        await this.getLists();
        await this.getListTipoDefeito();
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    public async makeCalculations(): Promise<void> {
        this.objMakeCalculations.emit();
    }

    async getLists(): Promise<void> {
        //await Promise.all([this.getListConfigRolos(), this.getListTipoCalha()]);
    }

    async getListTipoDefeito(): Promise<void> {
        await this.formularioService.getListDropDownList('rs005', 'tipo_defeito').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listTipoDefeito = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listTipoDefeitoOriginal = this.listTipoDefeito;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorTurnoAmostragem);
        });
    }

    async createFilterTipoDefeito(value: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listTipoDefeitoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listTipoDefeito = this.listTipoDefeitoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listTipoDefeito = this.listTipoDefeitoOriginal;
            }
        } else {
            this.listTipoDefeito = this.listTipoDefeitoOriginal;
        }
    }

    checkOutroDefeitosIsEnabled() {
        const defeitosSelecteds = this.formulario.get('tipo_defeito').value || [];
      
        console.log('Defeitos Selecionados:', defeitosSelecteds); 
      
        this.tipoDefeitosIsEnabled = defeitosSelecteds.includes("Outros");
      
        if (this.tipoDefeitosIsEnabled) {
          this.formulario.get('outro_defeito').setValidators(Validators.required);
        } else {
          this.formulario.get('outro_defeito').clearValidators();
          this.formulario.get('outro_defeito').reset();
        }
      
        console.log('Tipo Defeitos Ativado:', this.tipoDefeitosIsEnabled); 
      
        this.formulario.get('outro_defeito').updateValueAndValidity();
      }
    
}